// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-title {
  font-size: 1.1rem;
  font-weight: 600;
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 8px;
  margin-bottom: 0;
}

.dialog-content {
  min-width: 500px;
  max-width: 640px;
  padding-top: 12px !important;
}

/* ── Status banner ──────────────────────────────────────────────────── */
.status-banner {
  text-align: center;
  font-weight: 600;
  font-size: 0.95rem;
  padding: 10px 16px;
  border-radius: 4px;
  margin-bottom: 14px;
  border: 2px solid;
}

.status-banner.weighing {
  color: #1a5276;
  border-color: #1a5276;
  background: #eaf4fb;
}

/* ── Form sections ──────────────────────────────────────────────────── */
.form-section {
  margin-bottom: 16px;
}

.section-title {
  font-size: 0.9rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #444;
  margin-bottom: 8px;
}

.field-row {
  display: flex;
  gap: 16px;
  align-items: flex-end;
  flex-wrap: wrap;
}

.field {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 160px;
}

.field-label {
  font-size: 0.8rem;
  font-weight: 600;
  margin-bottom: 4px;
  color: #333;
}

.field-input {
  max-width: 220px;
}

/* ── Submit button accent ───────────────────────────────────────────── */

.btn-submit:disabled {
  opacity: 0.5;
  cursor: default;
}

.button-gap {
  gap: 8px;
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/spacer-details/batches/foam-measure-dialog/foam-measure-dialog.component.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,0EAA0E;AAC1E;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,0EAA0E;AAC1E;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA,0EAA0E;;AAE1E;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,QAAQ;AACV","sourcesContent":[".dialog-title {\n  font-size: 1.1rem;\n  font-weight: 600;\n  border-bottom: 1px solid #dee2e6;\n  padding-bottom: 8px;\n  margin-bottom: 0;\n}\n\n.dialog-content {\n  min-width: 500px;\n  max-width: 640px;\n  padding-top: 12px !important;\n}\n\n/* ── Status banner ──────────────────────────────────────────────────── */\n.status-banner {\n  text-align: center;\n  font-weight: 600;\n  font-size: 0.95rem;\n  padding: 10px 16px;\n  border-radius: 4px;\n  margin-bottom: 14px;\n  border: 2px solid;\n}\n\n.status-banner.weighing {\n  color: #1a5276;\n  border-color: #1a5276;\n  background: #eaf4fb;\n}\n\n/* ── Form sections ──────────────────────────────────────────────────── */\n.form-section {\n  margin-bottom: 16px;\n}\n\n.section-title {\n  font-size: 0.9rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #444;\n  margin-bottom: 8px;\n}\n\n.field-row {\n  display: flex;\n  gap: 16px;\n  align-items: flex-end;\n  flex-wrap: wrap;\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 160px;\n}\n\n.field-label {\n  font-size: 0.8rem;\n  font-weight: 600;\n  margin-bottom: 4px;\n  color: #333;\n}\n\n.field-input {\n  max-width: 220px;\n}\n\n/* ── Submit button accent ───────────────────────────────────────────── */\n\n.btn-submit:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.button-gap {\n  gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
